export default {
  props: ['noticeModule'],
  data() {
    return {
      leftList: [],
      rightList: []
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    handleMore() {
      window.location.href = `/news.html?module_name=${this.noticeModule.module_name}&menu_id=${this.noticeModule.menu_id}`;
    },
    async getNewsList() {
      const res = await this.$http.getNewsList({
        menu_id: this.noticeModule.menu_id,
        keyWord: '',
        '_pageable.page': 0,
        '_pageable.size': 4
      });
      this.leftList = res.content.slice(0, 2);
      this.rightList = res.content.slice(2, 4);
    },
    handleDetail(item) {
      if (item.news_type === 1) {
        window.location.href = `/newsDetail.html?id=${item.id}&module_name=${this.noticeModule.module_name}`;
      } else {
        window.open(item.news_url);
      }
    }
  }
};